module.exports = {
      id: "binding-usage",
      viewBox: "0 0 299.2 353.6",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#binding-usage",
      toString: function () {
        return this.url;
      }
    }